export function getTourTarget(name: string): HTMLElement | null {
  if (typeof document === "undefined") {
    return null;
  }

  return document.querySelector(`[data-tourId="${name}"]`);
}

export function waitForTourElement(selector: string, timeout = 1500): Promise<Element | null> {
  if (typeof document === "undefined") {
    return Promise.resolve(null);
  }

  const query = () => document.querySelector(`[data-tourId="${selector}"]`);

  return new Promise((resolve) => {
    const existing = query();
    if (existing) {
      resolve(existing);
      return;
    }

    let timerId: ReturnType<typeof setTimeout> | undefined;

    const observer = new MutationObserver(() => {
      const element = query();
      if (element) {
        observer.disconnect();
        if (timerId) {
          clearTimeout(timerId);
        }
        resolve(element);
      }
    });

    // If you get "parameter 1 is not of type 'Node'" error, see https://stackoverflow.com/a/77855838/492336
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["class"],
    });

    if (timeout > 0) {
      timerId = setTimeout(() => {
        observer.disconnect();
        resolve(null);
      }, timeout);
    }
  });
}
